"use client";

import { DialogTitle } from "@mui/material";
import { useNotifyDialog } from "../Providers/NotifyDialogContext";

export default function NotificationDialogTitle() {
  const { campaignIdsToNotify } = useNotifyDialog();

  return (
    <DialogTitle>
      {`Update Notification Settings for Campaign${campaignIdsToNotify.length > 1 ? "s" : ""}`}
    </DialogTitle>
  );
}
